package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AgregarSectorModal(
    onDismiss: () -> Unit,
    onConfirm: (nombre: String) -> Unit
) {
    var nombreSector by remember { mutableStateOf("") }

    // Capa de fondo oscura (Overlay)
    Div({
        style {
            position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
            backgroundColor(rgba(0, 0, 0, 0.6))
            display(DisplayStyle.Flex); justifyContent(JustifyContent.Center); alignItems(AlignItems.Center)
            property("z-index", "1100") // Un poco más arriba que el de patrullas por si acaso
        }
    }) {
        // Caja de contenido
        Div({
            style {
                width(400.px); backgroundColor(Color.white); borderRadius(12.px); padding(32.px)
                display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(20.px)
                property("box-shadow", "0px 4px 12px rgba(0, 0, 0, 0.2)")
            }
        }) {
            H2({ style { marginTop(0.px); color(Color("#1976D2")); textAlign("center") } }) {
                Text("Nuevo Sector Municipal")
            }

            P({ style { color(Color.gray); textAlign("center"); marginBottom(8.px) } }) {
                Text("Define una nueva zona de patrullaje para la ciudad de Arica.")
            }

            // Campo de Texto para el Nombre
            Div {
                Label(attrs = { style { fontWeight("bold"); display(DisplayStyle.Block); marginBottom(8.px) } }) {
                    Text("Nombre del Sector:")
                }
                Input(type = InputType.Text, attrs = {
                    value(nombreSector)
                    placeholder("Ej: Sector 7 - Chinchorro")
                    style {
                        padding(14.px); fontSize(16.px); width(100.percent);
                        boxSizing("border-box"); border(1.px, LineStyle.Solid, Color.lightgray);
                        borderRadius(6.px); outline("none")
                    }
                    onInput { event -> nombreSector = event.value }
                })
            }

            // Botonera de Acción
            Div({
                style { display(DisplayStyle.Flex); justifyContent(JustifyContent.End); gap(16.px); marginTop(10.px) }
            }) {
                // Botón Cancelar
                Button(attrs = {
                    onClick { onDismiss() }
                    style {
                        padding(12.px, 24.px); backgroundColor(Color("#E0E0E0"));
                        color(Color.black); border(0.px); borderRadius(8.px); cursor("pointer")
                    }
                }) { Text("Cerrar") }

                // Botón Confirmar
                Button(attrs = {
                    val canConfirm = nombreSector.isNotBlank()
                    onClick { if (canConfirm) onConfirm(nombreSector) }
                    if (!canConfirm) disabled()
                    style {
                        padding(12.px, 24.px);
                        backgroundColor(if (canConfirm) Color("#34A853") else Color.lightgray);
                        color(Color.white); border(0.px); borderRadius(8.px);
                        cursor(if (canConfirm) "pointer" else "not-allowed");
                        fontWeight("bold")
                    }
                }) { Text("Crear Sector") }
            }
        }
    }
}

